import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=02947fc0&scoped=true&"
import script from "./NoteModal.vue?vue&type=script&lang=ts&"
export * from "./NoteModal.vue?vue&type=script&lang=ts&"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=02947fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02947fc0",
  null
  
)

export default component.exports